'use strict';

function BtnToggler(selector) {
    this.$btn = $(selector);
}
BtnToggler.prototype.lock = function (info) {
    var $btn = this.$btn;
    $btn.prop('disabled', true);
    if (info) {
        this.text = $btn.html();
        $btn.html(info);
    }
};
BtnToggler.prototype.unlock = function () {
    var $btn = this.$btn;
    $btn.prop('disabled', false);
    var orgText = this.text;
    if (orgText) {
        $btn.html(orgText);
        this.text = undefined;
    }
};

export { BtnToggler };
